<script>
import vCard from 'vcard-parser';
import { VBTooltip } from 'bootstrap-vue';

export default {
  props: {
    message: {
      type: Object,
      required: true
    },
    isParent: {
      type: Boolean,
      default: false,
    }
  },

  directives: {
    'b-tooltip': VBTooltip
  },

  data () {
    return {
      contacts: [],
    };
  },

  created () {
    this.extractVCardData();
  },

  methods: {
    extractVCardData () {
      const result = vCard.parse(this.message.text);

      console.log(result);

      if (!(Array.isArray(result.tel) && result.tel.length > 0)) {
        return;
      }

      this.contacts = result.tel.map((tel, index) => {
        const contact = { infos: [] };

        if (this.validateContactInfo(result, 'fn', index)) {
          contact.infos.push({ name: 'Nome', value: result.fn[index].value });
        }

        contact.infos.push({ name: 'Telefone', value: tel.value });

        if (this.validateContactInfo(result, 'email', index)) {
          contact.infos.push({ name: 'E-mail', value: result.email[index].value });
        }

        return contact;
      });
    },

    validateContactInfo (result, property, index) {
      return (
        Array.isArray(result[property])
        && result[property][index]
        && result[property][index].value
      );
    }
  },
}
</script>

<template>
  <div class="attendence-contacts-container">
    <div
      v-for="contact of contacts"
      class="attendence-message-contact"
    >
      <div class="contact-title">
        <img src="/build/icons/address-book.svg" alt="Contato">
        <span class="ml-6px">Contato</span>
      </div>
      <div class="contact-info-container">
        <div
          v-for="info of contact.infos"
          class="info text-truncate"
          v-b-tooltip="{
            customClass: 'salesflow-tooltip'
          }"
          :title="info.value"
        >
          <span class="info-name">{{ info.name }}:</span>
          <span class="info-value ml-2px">{{ info.value }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins';

.attendence-contacts-container {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.attendence-message-contact {
  width: fit-content;
  max-width: 20rem;
  padding: 0.5rem 1rem;
  border-radius: 14px;
  border: 1px solid $salesflow-outline-gray-medium;
  @include salesflow-text();

  .contact-title {
    display: flex;
    align-items: center;
    font-weight: 600;
  }

  .contact-info-container {
    margin-top: 0.5rem;

    .info {
      max-width: 100%;

      .info-name {
        font-weight: 500;
      }

      .info-value {
        font-weight: 600;
      }
    }
  }
}

</style>
